import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", path: "/" },
  { label: "影视分类", path: "/category" },
  { label: "影视资讯", path: "/news" },
  { label: "关于我们", path: "/about" },
];

const categoryLinks = [
  { label: "电影", path: "/category?type=电影" },
  { label: "电视剧", path: "/category?type=电视剧" },
  { label: "国产剧", path: "/category?type=国产剧" },
  { label: "海外剧", path: "/category?type=海外剧" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-900 text-primary-50">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:px-6 lg:grid-cols-4 lg:gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
              <i className="ri-movie-2-line text-xl"></i>
            </span>
            <span className="text-lg font-extrabold font-heading">久久爱</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
            久久爱是专注影视内容推荐与资讯的平台，聚焦最新热门影视剧与经典作品。我们提供剧情简介、演员信息、评分与观影推荐，帮你在海量作品里找到真正想看的那一部。
          </p>
          <div className="mt-5 flex flex-col gap-2 text-sm text-primary-200">
            <p className="flex items-center gap-2">
              <i className="ri-mail-line"></i>
              <span>contact@jiujiuai.example.com</span>
            </p>
            <p className="flex items-center gap-2">
              <i className="ri-time-line"></i>
              <span>内容更新：每日 09:00 起滚动更新</span>
            </p>
          </div>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">快速导航</h4>
          <ul className="flex flex-col gap-3 text-sm text-primary-200">
            {quickLinks.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className="cursor-pointer transition-colors hover:text-background-50"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">影视分类</h4>
          <ul className="flex flex-col gap-3 text-sm text-primary-200">
            {categoryLinks.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className="cursor-pointer transition-colors hover:text-background-50"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-300 md:flex-row md:px-6">
          <p>© 2024 久久爱 · 本站所有内容均为演示数据，仅供产品展示使用</p>
          <p className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
            <span>隐私声明</span>
            <span className="hidden md:inline">·</span>
            <span>版权说明</span>
            <span className="hidden md:inline">·</span>
            <span>友情链接</span>
          </p>
        </div>
      </div>
    </footer>
  );
}